/**
 *
 * @Pattern https://mgechev.github.io/angularjs-in-patterns/#facade
 */

export default function Search(SearchService, SearchFactory) {
    var fn = this;

    fn.entries = [];
    /**
     * API v3
     */

    fn.groupedByWeeks = (start, weeks, activityId, locationId, isFixed) => {
        return SearchService.groupedByWeeks(
            start,
            weeks,
            activityId,
            locationId,
            isFixed
        );
    };

    fn.checkAvailability = (
        start,
        weeks,
        activityId,
        resourceId,
        isFixed,
        startTime,
        endTime
    ) => {
        return SearchService.checkAvailability(
            start,
            weeks,
            activityId,
            resourceId,
            isFixed,
            startTime,
            endTime
        );
    };

    return fn;
}
